import React from "react";
import Noti from "../../../util/noti";
import { OperatingTable } from "./OperatingTable";
import SiteCreationChild from "./SiteCreationChild";

function SiteCreationOperatingTable() {
	return (
		<SiteCreationChild requiredRoles={['administration:SiteCreation:_license']}>
			<OperatingTable />
			<Noti />
		</SiteCreationChild>
	);
}

export default SiteCreationOperatingTable;
